import * as React from 'react'

import LuxonUtils from 'material-ui-pickers/utils/luxon-utils'
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider'
import DatePicker from 'material-ui-pickers/DatePicker'
import * as moment from 'moment'

interface IDateInputProps {
  date?: Date
  onChange: (date?: Date) => void
}

class DateInput extends React.PureComponent<IDateInputProps> {
  // public dateMask = value => {
  //   return value
  //     ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  //     : []
  // }

  public render() {
    const { date, onChange } = this.props
    const defaultDate = moment()
      .startOf('month')
      .subtract(30, 'years')
      .toString()

    return (
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <DatePicker
          keyboard
          initialFocusedDate={defaultDate}
          label="Birthday *"
          value={date || null}
          fullWidth
          placeholder="1/1/1980"
          invalidDateMessage="Please enter date in 1/1/1980 format"
          format={'M/d/yyyy'}
          onChange={onChange}
          onError={this.handleError}
          disableOpenOnEnter
        />
      </MuiPickersUtilsProvider>
    )
  }

  private handleError = (e: any) => {
    this.props.onChange(undefined)
  }
}

export default DateInput



// WEBPACK FOOTER //
// ./src/components/shared/DateInput.tsx